<template>
  <div class="login-body">
    <div class="row borderNC">
      <div class="col-6 ml-auto mr-auto" style="height: 5px; border-top: #FD8700 solid 5px;"></div>
      <div class="col-6 ml-auto mr-auto" style="border-top:#FC3219 solid 5px;"></div>
    </div>
    <div class="container login-NC-Pro">
      <div class="row no-gutters justify-content-center align-items-center">
        <div class="col-lg-12 ml-auto mr-auto">
          <img src="@/assets/images/NC-Collection-Pro.png" alt="NC Core" />
        </div>
      </div>
      <slot />
      <span>© 2020 Nuevo Capital - Collection Pro.</span>
    </div>
  </div>
</template>

<script>
import '@/assets/css/material-components-web.min.css'
import '@/assets/css/icon.css'
import '@/assets/css/fonts.css'
import '@/assets/css/bootstrap.min.css'

export default {
	name: 'Default'
}
</script>



// WEBPACK FOOTER //
// src/components/Default.vue